"use client"
import { useFormStatus } from "react-dom"
import { Loader } from "lucide-react"
import { Button } from "@/components/atoms/Button/button"
import { cn } from '@/utils/index'

function ButtonLoader({ text }: { readonly text: string }) {
  return (
    <div className="flex items-center space-x-2">
      <Loader className="mr-2 h-4 w-4 animate-spin" />
      <p>{text}</p>
    </div>
  )
}

interface SubmitButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  loadingText: string
  className?: string
  loading?: boolean
  disabled?: boolean
  variant?: "default" | "outline"
}

export function SubmitButton({ text, loadingText, loading, disabled, className, variant }: Readonly<SubmitButtonProps>) {
  const status = useFormStatus()
  return (
    <Button
      type="submit"
      aria-disabled={status.pending || loading || disabled}
      disabled={status.pending || loading || disabled}
      className={cn(className)}
      variant={variant}
    >
      {status.pending || loading ? <ButtonLoader text={loadingText} /> : text}
    </Button>
  )
}
